<div *ngIf="error" class="alert alert-warning" role="alert">
  {{ errorMsg }}
</div>
<form (ngSubmit)="onSubmit()" [formGroup]="form" autocomplete="off">
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <div class="row">
          <div *ngIf="!layoutB2c" class="col-4 pl-0" >
            <label class="pessoa-label" i18n>Pessoa</label>
            <select id="select-tipo-pessoa-cadastro-cliente" formControlName="tipo"
              (change)="formatDocument($event.target.value)" [class]="
                edit
                  ? 'form-control select-tipo-pessoa-cadastro-cliente'
                  : 'form-control'
              " [disabled]="edit">
              <option value="CNPJ">Jurídica</option>
              <option value="CPF">Física</option>
            </select>
          </div>
          <div [class]="!layoutB2c ? 'col pr-0 documento1-col ':'pl-0 col pr-0 documento1-col '">
            <label i18n>{{form.get('tipo').value}}</label>
            <input id="numDocumento1" formControlName="numDocumento1" placeholder="{{ documentLabel1 }}"
              (blur)="consultaCnpj($event.target.value ,edit)" name="numDocumento1" type="text" [mask]="documentMask"
              [dropSpecialCharacters]="false" class="form-control" [readonly]="edit" />
            <div *ngIf="error && form.get('numDocumento1').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
          <div *ngIf="edit && form.controls.tipo.value === 'CNPJ'" class="col-3 pr-0 d-flex justify-content-center">
            <button type="button" class="btn btn-primary" (click)="consultaCnpj(selectedClient.numdocumento)">
              Atualiza Sefaz
            </button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-4 pl-0 tipo-empresa-col">
            <label i18n>Tipo Empresa</label>
            <select *ngIf="nomeLabel2" formControlName="tipo_empresa" class="form-control">
              <option *ngFor="let t of tipo_empresa" value="{{ t.id }}">
                {{ t.label }}
              </option>
            </select>
            <select *ngIf="!nomeLabel2" formControlName="tipo_empresa" class="form-control">
              <option *ngFor="let t of tipo_empresaPF" value="{{ t.id }}">
                {{ t.label }}
              </option>
            </select>
            <div *ngIf="error && form.get('tipo_empresa').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
          <div [class]="documentLabel1 === 'CNPJ' ? 'col-6 pr-0 documento2-col':'col-8 pr-0 documento2-col'">
            <label i18n>{{ documentLabel2 }}</label>
            <input id="numDocumento2" formControlName="numDocumento2" placeholder="{{ documentLabel2 }}"
              name="numDocumento2" type="text" class="form-control" maxlength="20" [readOnly]="isentoIE" />
            <div *ngIf="error && form.get('numDocumento2').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
          <div *ngIf="documentLabel1 === 'CNPJ'" class="col-1 pr-0">
            <label class="form-check-label" for="flexCheckDefault"
              [style]="'display: flex; margin-bottom: 0 !important'">
              Isento
            </label>
            <div [style]="cadastros ? 'display: flex; margin-right: 1rem' : 'display: flex;'">
              <input
                style="min-width: 1rem;" 
                class="form-control" 
                type="checkbox"
                [checked]="this.isentoIE" 
                (change)="isentoIE = !isentoIE; atualizaValidacaoNumDocumento()"
                id="flexCheckDefault" 
              />
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label i18n>{{ nomeLabel1 }}</label>
        <input formControlName="nome1" name="nome1" type="text" maxlength="60" class="form-control" />
        <div *ngIf="error && form.get('nome1').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div *ngIf="nomeLabel2" class="form-group">
        <label i18n>{{ nomeLabel2 }}</label>
        <input formControlName="nome2" name="nome2" type="text" maxlength="60" class="form-control" />
        <div *ngIf="error && form.get('nome2').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div class="form-group">
        <label i18n>Email Login</label>
        <input id="email-cadastro-cliente" formControlName="email" name="email" type="email" maxlength="60"
          class="form-control" [readOnly]="layoutB2c">
        <div *ngIf="error && form.get('email').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div *ngIf="documentLabel1 ==='CNPJ'" class="form-group email-contato-col">
        <label i18n>Email Contato</label>
        <input formControlName="emailContato" id="email-contato-cadastro-cliente" name="emailContato" type="email"
          maxlength="60" class="form-control" />
        <!-- <div *ngIf="error && form.get('email').invalid" class="error">
          Verifique este campo!
        </div> -->
      </div>
      <div *ngIf="documentLabel1 ==='CPF'" class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label i18n>Telefone Fixo</label>
            <input formControlName="ddd" name="ddd" type="text" mask="00" placeholder="DDD" class="form-control" />
            <div *ngIf="errorMsg && form.get('ddd').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label i18n>&nbsp;</label>
            <input formControlName="telefone" name="telefone" type="text" mask="0000-0000" [validation]="false"
              [dropSpecialCharacters]="false" placeholder="Número" class="form-control" />
              <div *ngIf="errorMsg && form.get('telefone')?.invalid" class="error">
                <ng-container *ngIf="form.get('telefone')?.errors as errors">
                  <span *ngIf="errors['required']">O telefone é obrigatório.</span>
                  <span *ngIf="errors['minlength']">O telefone deve ter pelo menos 9 dígitos.</span>
                  <span *ngIf="errors['pattern']">O telefone deve começar com 2, 3, 4 ou 5.</span>
                  <span *ngIf="!errors['required'] && !errors['minlength'] && !errors['pattern']">
                    Verifique este campo!
                  </span>
                </ng-container>
              </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div *ngIf="documentLabel1 ==='CNPJ'" class="col-4 pl-0 suframa-col">
          <div class="form-group">
            <label i18n>Suframa</label>
            <input formControlName="suframa" name="suframa" type="text" class="form-control" data-toggle="tooltip"
              data-placement="top" title="Apenas para clientes inscritos no suframa" id="suframa-cadastro-cliente" />
            <div *ngIf="errorMsg && form.get('suframa').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div *ngIf="documentLabel1 ==='CNPJ'" class="col-8 pr-0 referencia-col">
          <div class="form-group">
            <label i18n>Referências Comerciais</label>
            <input maxlength="60" formControlName="observacao" name="observacao" type="text" class="form-control"
              (input)="sanitizeInput($event)" id="ref-cadastro-cliente" />
            <div *ngIf="errorMsg && form.get('observacao').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="form-group mt-3">
        <div class="row">
          <div class="col-12 pl-0 pr-0">
            <!-- <table
              class="table table-hover table-sm"
              [innerHtml]="tableInfoDoc"
            ></table> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="row">
        <div class="col-8 pl-0">
          <div class="form-group">
            <label i18n>Endereço</label>
            <input formControlName="endereco" name="endereco" type="text" maxlength="43" class="form-control" />
            <div *ngIf="errorMsg && form.get('endereco').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-4 pr-0">
          <div class="form-group">
            <label i18n>Número</label>
            <input formControlName="numero" name="numero" type="text" maxlength="10" class="form-control" />
            <div *ngIf="errorMsg && form.get('numero').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-8 pl-0">
          <div class="form-group">
            <label i18n>Bairro</label>
            <input formControlName="bairro" name="bairro" type="text" maxlength="30" class="form-control" />
            <div *ngIf="errorMsg && form.get('bairro').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-4 pr-0">
          <div class="form-group">
            <label i18n>CEP</label>
            <!-- <input formControlName="cep" (change)="getCepValue($event.target.value)" name="cep" type="text" mask="00000-000" [dropSpecialCharacters]="true" -->
            <input formControlName="cep" name="cep" type="text" mask="00000-000" [dropSpecialCharacters]="true"           
            class="form-control" />
            <div *ngIf="errorMsg && form.get('cep').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-8 pl-0">
          <div class="form-group">
            <label i18n>Complemento</label>
            <input formControlName="complemento" name="complemento" type="text" maxlength="50" class="form-control" />
            <div *ngIf="errorMsg && form.get('complemento').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-4 pr-0 contato-col">
          <div class="form-group">
            <label i18n>Contato</label>
            <input formControlName="contato" name="contato" type="text" maxlength="50" class="form-control" />
            <div *ngIf="errorMsg && form.get('contato').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label i18n>UF</label>
            <select formControlName="uf" name="uf" (change)="searchCities()" class="form-control">
              <option *ngFor="let uf of ufs" value="{{ uf }}">{{ uf }}</option>
            </select>
            <div *ngIf="errorMsg && form.get('uf').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label i18n>Cidade</label>
            <select formControlName="cidade" id="cidade" name="cidade" class="form-control">
              <option *ngFor="let city of cities" value="{{ city.id }}">
                {{ city.nome }}
              </option>
            </select>
            <div *ngIf="errorMsg && form.get('cidade').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="documentLabel1 ==='CNPJ'" class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label i18n>Telefone fixo</label>
            <input formControlName="ddd" name="ddd" type="text" mask="00" placeholder="DDD" class="form-control" />
            <div *ngIf="errorMsg && form.get('ddd').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label i18n>&nbsp;</label>
            <input formControlName="telefone" name="telefone" type="text" mask="0000-0000" [validation]="false"
              [dropSpecialCharacters]="false" placeholder="Número" class="form-control" />
              <div *ngIf="errorMsg && form.get('telefone')?.invalid" class="error">
                <ng-container *ngIf="form.get('telefone')?.errors as errors">
                  <span *ngIf="errors['required']">O telefone é obrigatório.</span>
                  <span *ngIf="errors['minlength']">O telefone deve ter pelo menos 9 dígitos.</span>
                  <span *ngIf="errors['pattern']">O telefone deve começar com 2, 3, 4 ou 5.</span>
                  <span *ngIf="!errors['required'] && !errors['minlength'] && !errors['pattern']">
                    Verifique este campo!
                  </span>
                </ng-container>
              </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label i18n>Celular</label>
            <input formControlName="dddWhatsapp" name="dddWhatsapp" type="text" mask="00" placeholder="DDD"
              class="form-control" />
            <div *ngIf="errorMsg && form.get('dddWhatsapp').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label i18n>&nbsp;</label>
            <input formControlName="telefoneWhatsapp" name="telefoneWhatsapp" type="text" mask="00000-0000"
              [validation]="false" [dropSpecialCharacters]="false" placeholder="Número" class="form-control" />
            <div *ngIf="errorMsg && form.get('telefoneWhatsapp').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 pl-0 midia-social-input">
          <div class="form-group">
            <button (click)="openModal()" type="button" class="btn btn-primary mt-3" [style.backgroundColor]="backgroundColor">
              Mídias sociais
            </button>
          </div>
        </div>
        <div class="col-4 pl-0" *ngIf="cadastros">
          <div class="form-group">
            <label i18n>Tipo de cliente</label>
            <select id="select-tipo-cliente-cadastro-cliente" formControlName="tipo_cliente" name="tipo_cliente"
              [class]="edit ? 'form-control select-tipo-cliente-cadastro-cliente' : 'form-control'">
              <option *ngFor="let t of tipoCliente" [class]="t.class" [value]="t.value">
                {{ t.title }}
              </option>
              <!-- <option class="tipo-cliente-varejo" value="varejo">Varejo</option> -->
              <!--option class="tipo-cliente-atacado" value="atacado">
                Atacado
              </option>
              <option class="tipo-cliente-franquia" value="franquia">
                Franquia
              </option-->
            </select>
            <div *ngIf="errorMsg && form.get('tipo_cliente').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0" *ngIf="cadastros">
          <div class="form-group">
            <label i18n>Representante</label>
            <input [(ngModel)]="typingRepresentante" [ngModelOptions]="{ standalone: true }" [typeaheadAsync]="true"
              [typeahead]="representantes" typeaheadOptionField="{{ 'nome' }}" isAnimated="true"
              (typeaheadOnSelect)="onSelect($event)" (typeaheadNoResults)="typeaheadNoResults($event)" id="cliente"
              autocomplete="off" placeholder="Digite o nome do representante" i18n-placeholder="Client name"
              class="form-control" />
            <div *ngIf="noResult" class="alert alert-info" i18n>
              Nenhum registro encontrado!
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="lgpdCheck" class="row">
      <div class="col-12" style="margin-top: 10px; margin-bottom: 10px; display: flex; align-items: center; gap: 8px;">
        <label class="switch" for="checkbox">
          <input type="checkbox" id="checkbox" (change)="lgpdAccepted = !lgpdAccepted" [checked]="lgpdAccepted" />
          <div class="slider round"></div>
        </label>
        <label>Confirmo que li e aceito os <a [href]="lgpd" target="_blank">termos de privacidade</a>
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <button i18n class="btn btn-primary" *ngIf="this.edit; else btntitle">
        Salvar
      </button>
      <ng-template #btntitle>
        <button [disabled]="!lgpdAccepted && lgpdCheck" i18n class="btn btn-primary">Cadastrar</button>
      </ng-template>
    </div>
  </div>
  <div class="modal-overlay" *ngIf="isOpen">
    <!-- <div class="modal"> -->
      <div class="modal modal-content">
  
        <div class="modal-header">
          <h5 class="modal-title">Mídias sociais</h5>
        <button class="close" (click)="closeModal()">
          <span>x</span>
        </button>
      </div>
      <div class="modal-body">
          <div class="form-group">
            <label>Instagram</label>
            <input formControlName="instagram" name="instagram" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label>Facebook</label>
            <input formControlName="facebook" name="facebook"type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label>Twitter</label>
            <input formControlName="twitter" name="twitter" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label>TikTok</label>
            <input formControlName="tiktok" name="tiktok" type="text" class="form-control" />
          </div>
      </div>
      <div class="modal-footer">
        <button (click)="closeModal()" type="button" class="btn btn-primary mt-3"
        [style.backgroundColor]="backgroundColor">
        Salvar
      </button>
      </div>
    </div>
  </div>
</form>

<!-- </div> -->